import { render, staticRenderFns } from "./termsUse.vue?vue&type=template&id=3caebfd3&scoped=true"
var script = {}
import style0 from "./termsUse.vue?vue&type=style&index=0&id=3caebfd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caebfd3",
  null
  
)

export default component.exports